import api from './api';
import type { ClassItem, Pupil } from '../types';

/**
 * Class and Pupil Roster API Service
 */
export const classService = {
  /**
   * Fetches all classes mapped to the logged-in teacher context
   */
  getMyClasses: async (): Promise<ClassItem[]> => {
    const response = await api.get('/classes');
    return response.data.success ? response.data.data : [];
  },

  /**
   * Fetches full pupil demographic roster enrolled under specific class context
   */
  getClassPupils: async (classId: number): Promise<Pupil[]> => {
    const response = await api.get(`/classes/${classId}/pupils`);
    return response.data.success ? response.data.data : [];
  }
};

export default classService;
